
export const hardCodedInstitutions = [
  { // 1
    id: "69971818076716294",
    name: "Capital One Card Services",
    url: "https://www.capitalone.com/",
    bid: '7492',
    logoUrl: "https://s3.us-west-2.amazonaws.com/images.services.quicken.com/logos/fis/capital_one.png",
  },
  { // 2
    id: "69971818076716288",
    name: "Capital One 360",
    url: "https://home.capitalone360.com/",
    bid: '1236',
    logoUrl: "https://s3.us-west-2.amazonaws.com/images.services.quicken.com/logos/fis/capital_one_360.png",
  },
  { // 3
    id: "69971818076716293",
    name: "Capital One Card - Current",
    url: "http://www.capitalone.com/bank/services/investments/?linkid=WWW_0406_BANK_04_HOME_C1_04_T_BINV",
    bid: '20754',
    logoUrl: '',
  },
  { // 4
    id: "69971818076716289",
    name: "Capital One Auto Finance",
    url: "https://autorefi.capitalone.com/",
    bid: '54870',
    logoUrl: '',
  },
  { // 5
    id: "92122059351475713",
    name: "Capital One Bank - New",
    url: "https://www.capitalone.com/",
    bid: '17410',
    logoUrl: '',
  },
  { // 6
    id: "143726070794432768",
    name: "Capital One Mastercard Platinum (C",
    url: "https://www.capitalone.ca",
    bid: '66070',
    logoUrl: '',
  },
  { // 7
    id: "139232462857176321",
    name: "Capital One Costco MasterCard - CA",
    url: "https://www.capitalone.ca/",
    bid: '7460',
    logoUrl: '',
  },
  { // 8
    id: "69971818110270722",
    name: "Capital One Intellix Services",
    url: "https://intellix.capitalonebank.com/",
    bid: '15496',
    logoUrl: '',
  },
  { // 9
    id: "143726070794432772",
    name: "Capital One MilesOne Platinum Mast",
    url: "https://www.capitalone.com/",
    bid: '66065',
    logoUrl: '',
  },
  { // 10
    id: "143726070794432770",
    name: "Capital One MilesOne Visa Platinum",
    url: "https://www.capitalone.com/",
    bid: '66064',
    logoUrl: '',
  },
  { // 11
    id: '69971818059939080',
    name: 'Capital One - Mortgage Access',
    url: 'https://home.capitalone360.com',
    bid: '54885',
    logoUrl: '',
  },
  { // 12
    id: "143726070794432769",
    name: "Capital One No-Hassle Visa Platinu",
    url: "https://www.capitalone.com/",
    bid: '66066',
    logoUrl: '',
  },
  { // 13
    id: "69971818093493508",
    name: "Capital One Partner Card Services",
    url: "http://www.capitalonecardservice.com/",
    bid: '14587',
    logoUrl: '',
  },
  { // 14
    id: "69971818110270720",
    name: "Capital One Personal Loans",
    url: "http://www.capitalone.com/indexa.php",
    bid: '54789',
    logoUrl: '',
  },
  { // 15
    id: "139232462857176320",
    name: "Capital One Platinum - CA",
    url: "https://www.capitalone.ca",
    bid: '7463',
    logoUrl: '',
  },
  { // 16
    id: "143726070794432771",
    name: "Capital One Visa Business Platinum",
    url: "https://www.capitalone.com/",
    bid: '66063',
    logoUrl: '',
  },
  { // 17
    id: "69971817288187140",
    name: "Cabela's Club - Capital One",
    url: "http://www.cabelas.com",
    bid: '5236',
    logoUrl: '',
  },
  { // 18
    id: "143726074636415232",
    name: "GM Rewards (Capital One) Credit Ca",
    url: "https://gm.capitalone.com/",
    bid: '66161',
    logoUrl: '',
  },
  { // 19
    id: "143726077069111552",
    name: "Orchard Bank (Capital One) Credit",
    url: "https://www.capitalone.com/",
    bid: '66071',
    logoUrl: '',
  },
];

